// extracted by mini-css-extract-plugin
export var container = "_r0-0";
export var table = "_r0-2";
export var tableWrapper = "_r0-1";